// extracted by mini-css-extract-plugin
export default {"EditTop":"AddPropertyEnotif_EditTop__-fgbr","Actions":"AddPropertyEnotif_Actions__SqptR","Content":"AddPropertyEnotif_Content__kQBbp"};